import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Input, Modal} from "antd"

class PopupReceivedSewing extends Component {
    _handleChangeInput = (e) => {
        const {name, value} = e.target
        const {onChangeInput} = this.props

        if (typeof onChangeInput === 'function') {
            onChangeInput(name, value)
        }
    }

    render() {
        const {visible, receiveSewName, loading, onUpdate, onClose} = this.props

        return (
            <Modal
                title="Thông tin nhận may"
                className={'CustomModal'}
                visible={visible}
                width={650}
                onCancel={onClose}
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        size='large'
                        loading={loading}
                        onClick={onUpdate}
                        disabled={receiveSewName === '' || receiveSewName.trim() === ''}
                    >
                        Save
                    </Button>
                ]}
            >
                <div className='receiveSewName mb-3'>
                    <label className='d-block'>Người nhận may (<span className='text-danger'>* bắt buộc</span>)</label>
                    <Input
                        value={receiveSewName}
                        size='large'
                        name='receiveSewName'
                        placeholder={'Người nhận may'}
                        onChange={this._handleChangeInput}
                    />
                </div>
            </Modal>
        )
    }
}

PopupReceivedSewing.propTypes = {
    visible: PropTypes.bool.isRequired,
    receiveSewName: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onChangeInput: PropTypes.func.isRequired
}

export default PopupReceivedSewing
